/* eslint-disable no-empty */
/* eslint-disable implicit-arrow-linebreak */
import cornerstone from 'cornerstone-core';
import isEqual from 'lodash.isequal';
import axios from 'axios';
import * as dicomParser from 'dicom-parser';
import { getVolumeManager, getHeaderTags, getPixelDataArray } from '../../getVolumeManager';
import {
  TYPE_OPTION_MPR,
  TYPE_OPTION_VR,
  TYPE_OPTION_CORONAL_ANTERIOR,
  TYPE_OPTION_CORONAL_POSTERIOR,
  TYPE_OPTION_AXIAL_SUPERIOR,
  TYPE_OPTION_AXIAL_INFERIOR,
  TYPE_OPTION_SAGITAL_DERECHA,
  TYPE_OPTION_SAGITAL_IZQUIERDA,
} from './volumeInitOptions';
import { palettesVR } from '../../../../../util/palettesVRLoader';
import { getHeadersConfig } from '../../../../../util/getHeadersConfig';
import store from '../../../../../store/store';

export const CamerasMap = {
  [TYPE_OPTION_VR]: [
    { id: TYPE_OPTION_CORONAL_ANTERIOR, keysPressed: { key: 'r' } },
    { id: TYPE_OPTION_CORONAL_POSTERIOR, keysPressed: { key: 'l' } },
    { id: TYPE_OPTION_AXIAL_SUPERIOR, keysPressed: { key: 'a' } },
    { id: TYPE_OPTION_AXIAL_INFERIOR, keysPressed: { key: 'p' } },
    { id: TYPE_OPTION_SAGITAL_DERECHA, keysPressed: { key: 'h' } },
    { id: TYPE_OPTION_SAGITAL_IZQUIERDA, keysPressed: { key: 'f' } },
  ],

  [TYPE_OPTION_MPR]: [],
};

export class SerieCache {
  constructor(props = {}) {
    this.volumeManager3d = getVolumeManager();
    this.references = [];
    this.index = 1;
    this.instances = props.instances;
    this.instancesLoading = [];
    this.arrayData = new Array(props.instances.length - 1);
    this.arrayHeaders = new Array(props.instances.length - 1);
    this.firstImages = 0;
    this.running = false;
    this.stopped = false;
    this.config = store.getState((state) => state.config);
    this.layout = store.getState().layout;
  }

  startLoading = async (current) => {
    if (this.volumeManager3d === undefined || this.instances.length <= this.instancesLoading.length) return;

    if (!this.running) {
      this.stopped = false;
      this.running = true;

      await new Promise((resolve) => setTimeout(resolve, 100));
      this.loading(current);
    }
  };

  stopLoading = async () => {
    // if (this.references.length === 0) {
    this.stopped = true;

    for (let i = 0; i < 100; i++) {
      if (!this.running) break;
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    await new Promise((resolve) => setTimeout(resolve, 150));
    // }
  };

  bin2String = (array) => {
    let result = '';
    for (let i = 0; i < array.length; i++) {
      result += String.fromCharCode(parseInt(array[i], 2));
    }
    return result;
  };

  getImage = (index) =>
    new Promise((resolve) => {
      
      cornerstone
        .loadImage(this.instances[index])
        .then((image) => {
          this.arrayHeaders[index] = getHeaderTags(image.data);
          this.arrayData[index] = getPixelDataArray(image.data, this.arrayHeaders[index]);
          resolve();
        })
        .catch((err) => {
          this.stopped = false;
          console.error('error: ', err);
        });   
    }).catch((err) => {
      console.error(err);
    });

  getFirstImages = async () => {
    try {
      if (this.firstImages === 0 && this.instances.length !== this.instancesLoading.length) {
        this.firstImages = 1;
        this.instancesLoading.push(0);
        await this.getImage(0);
        const average = Math.floor((this.instances.length - 1) / 2);
        this.instancesLoading.push(average);
        await this.getImage(average);
        this.instancesLoading.push(this.instances.length - 1);
        await this.getImage(this.instances.length - 1);
        this.firstImages = 2;
      }
    } catch (error) {
      this.firstImages = 2;
    }

    for (let i = 0; i < 250; i++) {
      if (this.firstImages === 2) break;
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  };

  updateVolumeTexture = () => {
    try {
      if (this.volumeManager3d.all_views.length > 0) {
        this.volumeManager3d.updateVolumeTexture(this.arrayHeaders, this.arrayData, this.volumeManager3d.all_views);
      }
    } catch (error) {
      console.error(error);
    }
  };

  updateMessageReferences = () => {
    try {
      const percentage = parseInt((this.instancesLoading.length / this.instances.length) * 100, 10);
      this.references.forEach((reference) => {
        const current = reference.current;
        current.innerHTML = `Loading ${percentage}%`;
      });
    } catch (error) {
      console.error(error);
    }
  };

  noneDisplayReferences = () => {
    try {
      this.references.forEach((reference) => {
        const current = reference.current;
        current.style.display = 'none';
      });
    } catch (error) {}
  };

  loading = async (current) => {
    if (this.stopped) {
      this.running = false;
      return;
    }

    this.index = this.index < this.instancesLoading.length ? this.index : 1;
    const previousInstance = this.instancesLoading[this.index - 1];
    const actualInstance = this.instancesLoading[this.index];

    if (actualInstance - previousInstance > 1) {
      const average = Math.floor((actualInstance - previousInstance) / 2);
      const insertInstance = previousInstance + average;

      this.instancesLoading.splice(this.index, 0, insertInstance);
      await this.getImage(insertInstance);

      this.updateMessageReferences();

      this.index += 1;
    }

    this.index += 1;

    if (this.index >= this.instancesLoading.length && !this.stopped) this.updateVolumeTexture();

    if (this.instances.length > this.instancesLoading.length) {
      const interval = this.instancesLoading.length % 10 === 0 ? 100 : 1;
      setTimeout(() => this.loading(current), interval);
    } else {
      if (!this.stopped) this.updateVolumeTexture();

      this.noneDisplayReferences();

      this.running = false;
      this.stopped = true;

      // Temporary until 3D palettes on load views are fixed
      this.refreshVRViewsToFixPalette(current);
    }
  };

  refreshVRViewsToFixPalette = (current) => {
    let foundView;
    if (this.layout.is3DModeEnabled) {
      foundView = this.volumeManager3d.all_views.find(view => view.type === 'vr');
    } else {
      foundView = this.volumeManager3d.all_views.find(view => view.div.id === current.id);
    }
    if (!foundView) return;

    const foundViewDiv = foundView.div;
    const initOptions = foundView.options;
    const activeToolState = {
      toolLeft: this.volumeManager3d.toolLeft,
      toolRight: this.volumeManager3d.toolRight,
      lastTool: this.volumeManager3d.lastTool,
      annotationMode: this.volumeManager3d.annotationMode,
    };

    this.volumeManager3d.removeView(foundView.div);
    const refreshedView = this.volumeManager3d.addView(foundViewDiv, initOptions, this.arrayHeaders, this.arrayData);
    if (!refreshedView) return;

    Object.assign(this.volumeManager3d, activeToolState);
    this.volumeManager3d.all_views.forEach((view) => this.volumeManager3d.setToolDefault(view));
  }


  findView = (current) => {
    if (this.volumeManager3d === undefined) return;

    const views = this.volumeManager3d.all_views;

    for (let itView = 0; itView < views.length; itView++) {
      if (current.id === views[itView].div.id) {
        return views[itView];
      }
    }

    return undefined;
  };

  addView = (current, initOptions, loadingRef) => {
    if (this.volumeManager3d === undefined) return;

    const currentRef = loadingRef.current;
    this.references.push(loadingRef);
    let option = initOptions;
    if (initOptions) option.defaultPalettes = palettesVR; option.defaultPaletteName = this.config.config.DEFAULT_VR_PALETTE ?? '';
    this.volumeManager3d.addView(current, option, this.arrayHeaders, this.arrayData);

    if (this.instances.length > this.instancesLoading.length) {
      const percentage = 0; // parseInt((this.instancesLoading.length / this.instances.length) * 100);
      currentRef.style.display = 'block';
      currentRef.innerHTML = `Loading ${percentage}%`;
    } else {
      currentRef.style.display = 'none';
    }
  };

  changeView = (current) => {
    if (this.volumeManager3d === undefined) return;
    this.volumeManager3d.updateView(current);
  };
  
  removeViewId = async (id, loadingRef) => {
    if (this.volumeManager3d === undefined) return;

    this.references = this.references.filter((item) => item !== loadingRef);

    const { all_views } = this.volumeManager3d;
    const view = all_views.find((item) => item.div.id === id.toString());

    this.stopLoading();

    // console.log('current', current.div);
    if (view) {
      this.volumeManager3d.removeView(view.div);
    } else {
      console.error('Error find div by id', id);
    }
  };

  changedViewType = (current, initOptions, oldViewType) => {
    if (this.volumeManager3d === undefined) return;
    const view = this.findView(current);

    if (view) {
      if (oldViewType.type !== initOptions.viewType.type) {
        try {
          this.volumeManager3d.changeViewType(view, initOptions);
        } catch (error) {}
      }

      if (view.camera) {
        if (view.camera.cameraType !== initOptions.viewType.camera) {
          view.camera.setViewMatrixPreDef(initOptions.viewType.camera);
        }
      }
    }
  };

  resizeViews = () => {
    if (this.volumeManager3d === undefined) return;

    this.volumeManager3d.resizeCanvasAndDivs();
  };

  downHandler = (current, viewType, propsKeys) => {
    if (this.volumeManager3d === undefined) return;

    const { repeat, ctrlKey, altKey, metaKey, shiftKey, key } = propsKeys;
    const view = this.findView(current);

    if (repeat) return;

    const keysPressed = {
      ...(altKey ? { altKey } : {}),
      ...(ctrlKey ? { ctrlKey } : {}),
      ...(shiftKey ? { ctrlKey } : {}),
      ...(metaKey ? { ctrlKey } : {}),
      ...(key !== 'Control' && key !== 'Shift' && key !== 'Alt' && key !== 'Meta' ? { key: key.toLowerCase() } : {}),
    };

    if (viewType.type === TYPE_OPTION_VR) {
      const cameras = CamerasMap[TYPE_OPTION_VR];

      for (let i = 0; i < cameras.length; i++) {
        const camera = cameras[i];

        if (isEqual(camera.keysPressed, keysPressed)) {
          view.camera.setViewMatrixPreDef(camera.id);
          break;
        }
      }
    }
  };
}
